import { Box, Typography } from "@mui/material";
import useColors from "../../../../api/hooks/useColors";

import usePermissionType from "./usePermissionType";
const AdminChip = ({ permissionType, category, withLabel }) => {
  const colors = useColors();
  const getPermissionType = usePermissionType();

  const {
    icon: Icon,
    borderColor,
    permissionLabel,
  } = getPermissionType(permissionType, category);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        borderRadius: "8px",
        fontSize: "12px",
        border: `0.5px solid ${borderColor}`,
        color: colors.text_secondary,
        backgroundColor: "transparent",
        padding: "4px",
      }}
    >
      {Icon && <Icon style={{ marginRight: withLabel ? "4px" : "0" }} />}
      {withLabel && (
        <Typography variant="caption" component="span">
          {permissionLabel}
        </Typography>
      )}
    </Box>
  );
};

export default AdminChip;
